module.exports = __webpack_public_path__ + "img/logo.76568335.jpg";